var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FilterFields',{attrs:{"fields":[
      {
        type: 'text',
        label: 'Código',
        field: 'codigo',
      },
      {
        type: 'text',
        label: 'Nome',
        field: 'nome',
      },
      {
        type: 'text',
        label: 'Fantasia',
        field: 'nome_fantasia',
      },
      {
        type: 'text',
        label: 'CPF/CNPJ',
        field: 'cnpj_cpf',
      },
      {
        type: 'date',
        label: 'Data Cadastro',
        field: 'created_at',
      },
      {
        type: 'text',
        label: 'Logradouro',
        field: 'logradouro',
      },
      {
        type: 'text',
        label: 'Bairro',
        field: 'bairro',
      },
      {
        type: 'text',
        label: 'Cidade',
        field: 'cidade',
      },
      {
        type: 'text',
        label: 'UF',
        field: 'uf',
      },
      {
        type: 'text',
        label: 'Profissão',
        field: 'profissao',
      },
      {
        type: 'text',
        label: 'Telefone',
        field: 'fone',
      },
      {
        type: 'text',
        label: 'Representante',
        field: 'representante',
      },
      {
        type: 'select',
        label: 'Tipo',
        field: 'tipo',
        options: ['Cliente', 'Fornecedor', 'Transportador', 'Todos'],
      },
    ]}}),_c('TableApp',{ref:"pessoa",attrs:{"titulo":"Pessoas","subTitulo":"Clientes / Fornecedores / Transportadoras","acaoBtn":"/#/pessoas/nova","textoBtn":"Novo","api-url":"pessoa","fields":_vm.fields,"classFilterColumn":"pessoa","perPage":10},scopedSlots:_vm._u([{key:"customRow",fn:function(props){return [(props.field == 'codigo')?_c('span',{attrs:{"slot":"codigo"},slot:"codigo"},[_c('span',{staticStyle:{"width":"110px"}},[_c('div',{staticClass:"font-weight-bolder font-size-lg mb-0"},[_vm._v(" "+_vm._s(props.rowData.codigo)+" ")])])]):_vm._e(),(props.field == 'nome')?_c('span',{attrs:{"slot":"nome"},slot:"nome"},[_c('span',{staticClass:"pl-0 pt-8"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"symbol symbol-40 symbol-light-primary flex-shrink-0",staticStyle:{"margin-right":"10px"}}),_c('div',[_c('a',{staticClass:"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg",attrs:{"href":"#"}},[_vm._v(_vm._s(props.rowData.nome))]),_vm._l((props.rowData.pessoa_tipo),function(tipoPessoa){return _c('span',{key:tipoPessoa.id_pessoa,staticClass:"text-muted font-weight-bold d-block"},[_vm._v(_vm._s(tipoPessoa.tipo.descricao))])})],2)])])]):_vm._e(),(props.field == 'nome_fantasia')?_c('span',{attrs:{"slot":"nome_fantasia"},slot:"nome_fantasia"},[_c('span',{staticStyle:{"width":"110px"}},[_c('div',{staticClass:"font-weight-bolder font-size-lg mb-0"},[_vm._v(" "+_vm._s(props.rowData.nome_fantasia)+" ")])])]):_vm._e(),(props.field == 'fones')?_c('span',{attrs:{"slot":"fones"},slot:"fones"},[_c('span',{staticClass:"pl-0 pt-8"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg",staticStyle:{"font-size":"12px"}},[_vm._v(" "+_vm._s(_vm.formatFones(props.rowData.fones))+" ")])])])]):_vm._e(),(props.field == 'cnpj_cpf')?_c('span',{attrs:{"slot":"cnpj_cpf"},slot:"cnpj_cpf"},[(props.rowData.cnpj_cpf)?_c('span',{staticStyle:{"width":"110px"}},[_c('div',{staticClass:"font-weight-bolder font-size-lg mb-0",staticStyle:{"font-size":"12px"}},[_vm._v(" "+_vm._s(_vm.formatarCampo(props.rowData.cnpj_cpf))+" ")]),(props.rowData.ie_rg)?_c('div',{staticClass:"font-weight-bold text-muted",staticStyle:{"font-size":"10px"}},[_vm._v(" IE/RG: "+_vm._s(props.rowData.ie_rg)+" ")]):_vm._e()]):_vm._e()]):_vm._e(),(props.field == 'created_at')?_c('span',{attrs:{"slot":"created_at"},slot:"created_at"},[_c('span',{staticStyle:{"width":"110px"}},[_c('div',{staticClass:"font-weight-bolder font-size-lg mb-0"},[_vm._v(" "+_vm._s(_vm.formatDate(props.rowData.created_at))+" ")])])]):_vm._e(),(props.field == 'status')?_c('span',{attrs:{"slot":"status"},slot:"status"},[(props.rowData.status == 'A')?_c('span',{staticClass:"label label-lg label-inline label-light-success"},[_vm._v("Ativo")]):_c('span',{staticClass:"label label-lg label-inline label-light-danger"},[_vm._v("Inativo")])]):_vm._e(),(props.field == 'actions')?_c('span',{attrs:{"slot":"actions"},slot:"actions"},[_c('div',{staticClass:"row-actions",staticStyle:{"text-align":"right !important"}},[_c('span',{staticStyle:{"overflow":"visible","position":"relative","width":"130px"}},[_c('div',{staticClass:"dropdown dropdown-inline"},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:('Histórico'),expression:"'Histórico'"}],staticClass:"btn btn-sm btn-success btn-hover-success btn-icon mr-2",on:{"click":function($event){return _vm.gerarHistoricoCliente(props.rowData)}}},[_c('ChartBar',{attrs:{"size":16}})],1),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:('Editar'),expression:"'Editar'"}],staticClass:"btn btn-sm btn-info btn-hover-info btn-icon mr-2",attrs:{"to":{
                  name: 'pessoasEditar',
                  params: {
                    id_pessoa: props.rowData.id_pessoa,
                  },
                }}},[_c('Pencil',{attrs:{"size":16,"title":"Editar"}})],1),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:('Excluir'),expression:"'Excluir'"}],staticClass:"btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('TrashCanIcon',{attrs:{"size":16}})],1)],1)])])]):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }